module.exports = __webpack_public_path__ + "img/3.2.311d254c.svg";